import React from 'react';
import { Link, useNavigate } from '@tanstack/react-router';
import { getGetCompanyDepartmentsQueryOptions } from '@area-restrita/api-client/endpoints/departments/departments.gen';

import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';
import { useQueryTable } from '@/hooks/useQueryTable';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import DataGrid from '@/components/DataGrid';
import { cn } from '@/lib/utils';

import { columns } from './columns';

const CompanyDepartments: React.FC = () => {
  const navigate = useNavigate();
  const { checkAuthorization } = useAuthSessionStore();

  const {
    table,
    query: { isLoading },
  } = useQueryTable({
    columns,
    getQueryOptions: getGetCompanyDepartmentsQueryOptions,
  });

  const canCreate = checkAuthorization(({ can }) =>
    can('create', 'departments'),
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>Departamentos</CardTitle>
        <CardDescription>
          Gerencie os departamentos das empresas.
        </CardDescription>
      </CardHeader>

      <CardContent className="p-0">
        <DataGrid
          table={table}
          isLoading={isLoading}
          actions={
            <Link
              to="/settings/company-departments/new"
              className={cn({
                hidden: !canCreate,
              })}
            >
              <Button size="sm">Novo departamento</Button>
            </Link>
          }
          onRowClick={(department) =>
            navigate({
              to: '/settings/company-departments/$departmentId',
              params: { departmentId: department.id },
            })
          }
        />
      </CardContent>
    </Card>
  );
};

export default CompanyDepartments;
